export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login failed, please try again.",
  requestFailed: "Request failed, please check your internet connection.",
  invalidLogin: "Invalid Username or Password.",
  invalidPassword: "Invalid Username or Password.",
  thisFunctionExists: "This function is already exists.",
  thisFunctionNotAllowDelete: "This function is not allow to delete.",
  thisFunctionNotExists: "This function is not exists.",
  targetFunctionIdRequired: "Target Function ID is required.",
  thisPageExists: "This page is already exists.",
  thisPageNotAllowDelete: "This page is not allow to delete.",
  thisRoleExists: "This role is already exists.",
  thisRoleNotAllowDelete: "This role is not allow to delete.",
  targetRoleIdRequired: "Target Role ID is required.",
  invalidParameter: "Invalid Parameter.",
  systemError: "System unable to process your request.",
  spErrorMessage: "SP Message Error (Depend what error).",
  actionbyRequired: "Current User is required.",
  sessionTokenRequired: "Session Token is required.",
  functionIdRequired: "Function ID is required.",
  functionNameRequired: "Function name is required.",
  newFunctionNameRequired: "Function name is required.",
  pageIdRequired: "Page ID is required.",
  newPageIdRequired: "Page ID is required.",
  newPageNameRequired: "Page name is required.",
  targetPageIdRequired: "Target Page ID is required.",
  userIdRequired: "User ID is required",
  passwordRequired: "Password is required.",
  userNameRequired: "Full Name is required.",
  passwordValidation: "Password must be 6-20 characters and a combination of number(s) and letter(s).",
  pageNumRequired: "Page Number is required.",
  pageSizeRequired: "Page Size is required.",
  roleIdRequired: "Role ID is required",
  oldPasswordRequired: "Current Password is required.",
  userStatusRequired: "User Status is required.",
  newRoleIdRequired: "Role ID is required.",
  newRoleNameRequired: "Role Name is required.",
  startDateRequired: "Start Date is required.",
  endDateRequired: "End Date is required.",
  startDateIsGteEndDate: "Start Date is greater than End Date.",
  sportsTypeRequired: "Sports Type is required.",
  teamTypeRequired: "Team Type is required.",
  thisRoleNotExists: "This Role is not exists.",
  thisPageNotExists: "This Page is not exists.",
  thisUserExists: "This User is already exists.",
  thisUserNotExists: "This User is not exists.",
  thisUserBlackListed: "Your account has been suspended.",
  thisUserInactive: "Your account has been disabled.",
  thisUserBlocked: "Your account has been blocked.",
  thisUserNotActive: "Your account has been disabled.",
  InvalidPageFunction:"Invalid Page Function.",
  invalidUser: "Invalid User!",
  invalidToken: "Invalid Session!",
  NoUserAccessRight: "Permission Denied!",
  unableSPProcess: "System unable to process your request.",
  connection: "Connection Error",
  thisProviderExists: "This provider is already exists.",
  thisProviderNotExists: "This provider is not exists.",
  thisProviderNotAllowDelete: "This provider is not allowed to delete, it has been used.",
  thisHostExists: "This host is already exists.",
  thisHostNotExists: "This host is not exists.",
  thisHostUrlExists: "This host URL is already exists.",
  thisProxyNotExists: "This proxy is not exists.",
  thisProxyExists: "This proxy is already exists.",
  hostUrlRequired: "Host URL is required.",
  targetHostIdRequired: "Target Host ID is required.",
  newProviderIdRequired: "Provider ID is required.",
  newHostUrlRequired: "Host URL is required.",
  hostIdRequired: "Host ID is required.",
  hostDisabledRequired: "Host Disabled is required.",
  providerIdRequired: "Provider ID is required.",
  providerNameRequired: "Provider Name is required.",
  targetProviderIdRequired: "Target Provider ID is required.",
  newProviderNameRequired: "Provider Name is required.",
  providerDisabledRequired: "Provider Disabled is required.",
  loginIdRequired: "Login ID is required.",
  loginNameRequired: "Login Name is required.",
  targetLoginIdRequired: "Target Login ID is required.",
  newHostIdRequired: "Host ID is required.",
  newLoginNameRequired: "Login Name is required.",
  loginDisabledRequired: "Login Disabled is required.",
  thisLoginExists: "This Login is already exists.",
  thisLoginNotExists: "This Login is not exists.",
  linkIdIsNotNull: "Link Id is not null",
  isAutomapLeague: "Automap league is not allow to purge",
  isAutomapTeam: "Automap team is not allow to purge",
  consoleLeagueRequired: "Console League is required.",
  consoleTeamRequired: "Console Team is required.",
  consoleTypeRequired: "Console Type is required.",
  sboLeagueRequired: "SBO League is required.",
  ibcLeagueRequired: "IBC League is required.",
  sboHomeRequired: "SBO Home Team is required.",
  ibcHomeRequired: "IBC Home Team is required.",
  sboAwayRequired: "SBO Away Team is required.",
  ibcAwayRequired: "IBC Away Team is required.",
  thisLeagueExists: "This league is already exists.",
  thisLeagueNotExists: "This league is not exists.",
  thisTeamExists: "This team is already exists.",
  thisTeamNotExists: "This team is not exists.",
  thisBotExists: "This bot is already exists.",
  thisBotNotExists: "This bot is not exists.",
  thisJobControlNotExists: "This Job control is not exists.",
  thisProxyNotAllowDelete: "This proxy is not allowed to delete, it has been used.",
  thisMatchExists: "This match is already exists.",
  thisMatchNotExists: "This match is not exists.",
  mapParentMatchFirst: "Please map parent match first.",
  mapParentLeagueFirst: "Please map parent league first.",
  mapLeagueOfMatch: "Please map league of match \"{name}\".",
  mapParentHomeFirst: "Please map parent home team first.",
  mapHomeOfMatch: "Please map home team of match \"{name}\".",
  mapParentAwayFirst: "Please map parent away team first.",
  mapAwayOfMatch: "Please map away team of match \"{name}\".",
  parentMatchNotFound: "Parent match not found.",
  consoleTypeNotFound: "Console Type not found",
  notSpecialMatch: "This match is not special match.",
  isSpecialMatch: "This match is special match.",
  isSingleProviderMatch: "Single provider match is not allow to unmap",
  parentLeagueNotFound: "Parent League Not Found",
  matchIdRequired: "Match Id is required",
  leagueIdRequired: "League Id is required",
  teamIdRequired: "Team Id is required",
  sportIdRequired: "Sport Id is required",
  notMappedLeague: "This league is not mapped.",
  notMappedTeam: "This team is not mapped.",
  thisLoginNotAllowDisable: "This login is not allowed to disable, it has been used.",
  thisLoginNotAllowDelete: "This login is not allowed to delete, it has been used.",
  thisLoginNotAssignToBot: "This login is not allowed to delete, it has been used.",
  thisProxyNotAllowDisable: "This proxy is not assign to any bot.",
  invalidSearchCriteriaFormat: "Invalid search criteria format.",
  matchListIsEmpty: "Match list is empty",
  isMappedMatch: "This match is not allowed to delete, it has been mapped.",
  dateDiffMoreThanOne: "The match date difference between SBO and IBC match more than one day, not allow to map",
  cannotUnlinkParentLeague: "Cannot Unlink Parent League.",
  invalidActionBy: "Invalid Action By.",
  invalidSessionToken: "Invalid Session Token.",
  invalidPageId: "Invalid Page Id.",
  invalidSportId: "Invalid Sport Id.",
  invalidProviderId: "Invalid Provider Id.",
  invalidProvider: "Invalid Provider.",
  invalidLeagueName: "Invalid League Name.",
  invalidLeagueId: "Invalid League Id.",
  invalidPageNumber: "Invalid Page Number.",
  invalidPageSize: "Invalid Page Size.",
  invalidSortKey: "Invalid Sort Key.",
  invalidSortType: "Invalid Sort Type.",
  invalidsboLeague: "Invalid SBO League.",
  invalidibcLeague: "Invalid IBC League.",
  invalidMapFrom: "Invalid Map From.",
  invalidMapTo: "Invalid Map To.",
  invalidsboId: "Invalid SBO Id.",
  invalidibcId: "Invalid IBC Id.",
  invalidcmdId: "Invalid CMD Id.",
  invalidPreferId: "Invalid Prefer Id.",
  invalidPreferProvider: "Invalid Prefer Provider.",
  invalidMatchId: "Invalid Match Id.",
  invalidHomeId: "Invalid Home Id.",
  invalidAwayId: "Invalid Away Id.",
  invalidParentMatchId: "Invalid Parent Match Id.",
  invalidMatchDate: "Invalid Match Date.",
  invalidMatchTime: "Invalid Match Time.",
  invalidMarketType: "Invalid Market Type.",
  invalidMatchType: "Invalid Match Type.",
  invalidGroupId: "Invalid Group Id.",
  invalidOddsId: "Invalid Odds Id.",
  invalidsboMatchId: "Invalid SBO Match Id.",
  invalidibcMatchId: "Invalid IBC Match Id.",
  invalidBetType: "Invalid Bet Type.",
  invalidOt: "Invalid OT.",
  invalidChildMatchId: "Invalid Child Match Id",
  invalidParentLeagueId: "Invalid Parent League Id",
  invalidsboMatch: "Invalid SBO Match.",
  invalidibcMatch: "Invalid IBC Match.",
  invalidAffectValue: "Invalid Affect Value",
  invalidTeamName: "Invalid Team Name",
  invalidTeamId: "Invalid Team Id",
  invalidsboTeam: "Invalid SBO Team.",
  invalidibcTeam: "Invalid IBC Team.",
  invalidBotId: "Invalid Bot Id",
  invalidBotName: "Invalid Bot Name",
  invalidRemark: "Invalid Remark",
  invalidTargetBotId: "Invalid Target Bot Id",
  invalidNewBotName: "Invalid New Bot Name",
  invalidTimeSync: "Invalid Time Sync",
  invalidHostUrl: "Invalid Host Url",
  invalidTargetHostId: "Invalid Target Host Id",
  invalidNewProviderId: "Invalid New Provider Id",
  invalidNewHostUrl: "Invalid New Host Url",
  invalidHostId: "invalid Host Id",
  hostDisabledRequired: "Host Disabled is required.",
  notAutomapTeam: "Not automap team is not allow to purge",
  ibcMatchExists: "IBC match exists, not allow to purge",
  linkedMatchExists: "Linked match exists, not allow to purge",
  invalidHomeTeam: "Invalid Home Team",
  invalidAwayTeam: "Invalid Away Team",
  thisRSRTControlNotExists: "This RS RT control is not exists.",
  disabledOptionRequired: "Disabled option is required.",
  loginInUse: "Login is use by another bot.",
  repullProcessing: "Repull is processing now, please try again later..",
  requestTooFrequent: "Sending data too frequent, please try again later..",
  rtfTypeRequired: "RTF Type is required.",
  gameIdRequired: "Game Id is required.",
  invalidGameId: "Invalid Game Id is required.",
  eventCodeIdRequired: "Event Code Id is required.",
  invalidEventCodeId: "Invalid Event Code Id",
  eventCodeRequired: "Event Code is required.",
  teamRequired: "Team is required.",
  allowOneDayRepull: "Only allow single day repull.",
  ukeyRequired: "UKey is required.",
  signatureRequired: "Signature is required.",
  requestRequired: "Request is required.",
  responseRequired: "Response is required.",
  videoNameRequired: "Video Name is required.",
  outputFileNameRequired: "Output file name is required.",
  invalidSignature: "Invalid Signature",
  readFileContentFailed: "Read file content failed.",
  invalidTargetLoginId: "Invalid Target Login ID.",
  targetBotIdRequired: "Target Bot ID is required.",
  invalidTargetBotId: "Invalid Target Bot ID.",
  duplicateMatchFound: "Duplicate Match Found.",
  notWhitelistedIp: "Not Whitelisted IP.",
  ipRequired: "IP is required.",
  invalidIp: "Invalid IP.",
  targetIpRequired: "Target IP is required.",
  invalidTargetIp: "Invalid Target IP.",
  ipExists: "IP is already exists.",
  ipNotExists: "IP is not exists.",
  invalidPin: "Invalid Pin.",

  loginDataRequired: "Login Data is required.",
  teamNameMinTwoChar: "Please enter at least 2 characters of team name to search.",
  leagueNameMinTwoChar: "Please enter at least 2 characters of league name to search.",

  isRequired: "Please enter a {fname}.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isNumeric: "{fname} accept only numerics.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  selectOption: "Please select a {fname}",
  notSameAs: "{fname} and {fname2} cannot be the same.",

  serverBusy: "Server is busy now. Please try again.",

  codeRequired: "Code is required.",
  noChanges: "No changes.",
  permissionDenied: "Permission denied.",
  secretKeyRequired: "Secret key is required.",
  otp2faEnabled: "2FA is enabled.",
  keyNotMatch: "Key not match.",
  otp2faDisabled: "2FA is disabled.",
  tokenRequired: "Token is required.",
  invalidSession: "Invalid session.",
  invalidCode: "Invalid code.",
};
